import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state to prevent rendering the faulty component
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details to the console
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render nothing to keep the UI intact
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
